import { useTranslation } from 'react-i18next'
import { CompanyBusinessSegmentType, UserSalutationType, NewUserForm } from '@saf/saf-kundenportal-frontend-api'
import { AutocompleteOption } from '~shared/models/AutocompleteOption'

export type NewUserFormSteps = keyof NewUserForm
export type NewUserPossibleFormStepValues = NewUserForm[NewUserFormSteps]

export const useCompanyBusinessSegmentTypeOptions: () => AutocompleteOption[] = () => {
  const { t } = useTranslation()

  return [
    { value: CompanyBusinessSegmentType.VEHICLEDEALER, label: t('form:vehicleManufacturer') },
    { value: CompanyBusinessSegmentType.WORKSHOP, label: t('form:workshop') },
    { value: CompanyBusinessSegmentType.PARTSDEALER, label: t('form:partsDealer') },
    { value: CompanyBusinessSegmentType.FLEET, label: t('form:fleetOrDispatchDepartment') },
  ]
}

export const useUserSalutationTypeOptions: () => AutocompleteOption[] = () => {
  const { t } = useTranslation()

  return [
    { value: UserSalutationType.SIR, label: t('form:salutationSIR') },
    { value: UserSalutationType.MADAM, label: t('form:salutationMADAM') },
    { value: UserSalutationType.DR, label: t('form:salutationDR') },
    { value: UserSalutationType.PROF, label: t('form:salutationPROF') },
  ]
}
